import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">瓜友热评</h2>
          <p className="text-foreground-600 text-sm md:text-base">百万吃瓜群众的真实声音</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="flex gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <img
                src={comment.avatar}
                alt={comment.name}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full flex-shrink-0 object-cover"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                  {comment.tag && (
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                      comment.tag === '热评'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}>
                      {comment.tag}
                    </span>
                  )}
                  <span className="text-xs text-foreground-500 ml-auto">{comment.time}</span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
                <div className="flex items-center gap-4 mt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-thumb-up-line"></i>
                    {comment.likes}万
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-chat-1-line"></i>
                    回复
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-share-forward-line"></i>
                    分享
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}